
const isMobile = {
    android: ()=> window.navigator.userAgent.match(/android/i),
    ios: ()=>window.navigator.userAgent.match(/iphone/i),
    windows: ()=>window.navigator.userAgent.match(/windows phone/i),
    any:function () {
        return this.android() || this.ios() || this.windows();
    }
}

// https://www.youtube.com/watch?v=WHfyN411fd4
export default isMobile;

